// src/components/EmptyState.js
import React from 'react';

const EmptyState = ({ type, onReset }) => {
  // Different states: "welcome", "no-results", "error"
  
  if (type === "welcome") {
    return (
      <div className="text-center py-16">
       
      </div>
    );
  }
    
  if (type === "no-results") {
    return (
      <div className="text-center text-gray-400 py-12">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-600 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="text-xl font-semibold mb-2">No games found</p>
        <p className="mb-6">Try adjusting your search or filters to find more games.</p>
        <button 
          onClick={onReset}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
        >
          Reset All Filters
        </button>
      </div>
    );
  }
  
  if (type === "error") {
    return (
      <div className="text-center py-12">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-red-500 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="text-xl font-semibold text-red-400 mb-2">Something went wrong</p>
        <p className="text-gray-400 mb-6">There was an error fetching games. Please try again.</p>
        <button 
          onClick={onReset}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
        >
          Try Again
        </button>
      </div>
    );
  }
  
  return null;
};

export default EmptyState;